import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconTrash = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <g>
      <rect width="16" height="16" rx="0" fill="none" />
      <path
        d="M12 14H4V6H2V4h4V2h4v2h4v2h-2v8Zm-2-2V6H9v6h1ZM7 6H6v6h1V6Z"
        fill={color}
      />
    </g>
  ),
})``;

export default IconTrash;
